<template>
  <div
    class="sf-accordion"
    :style="{ height: bodyHeight }"
    :class="visibleClass"
    @transitionend="onTranstionEnd"
  >
    <div ref="accordionBody" :class="dummyClass">
      <div v-if="isActive">
        <slot @resized="refreshHeight" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.sf-accordion {
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    show: Boolean,
    unmountOnHide: Boolean,
  },
  emits: ["transtionend"],
  data() {
    return {
      fullHeight: 0,
      targetHeight: 0,
      isAuto: false,
      observer: null as null | MutationObserver,
      isActive: false,
    };
  },
  computed: {
    visibleClass() {
      if (this.show) {
        return "sf-accordion-show";
      }
      return "sf-accordion-hide";
    },
    bodyHeight() {
      return this.isAuto ? "auto" : this.targetHeight + "px";
    },
    dummyClass() {
      return "sf-accordion-hd-cls_" + this.bodyHeight;
    },
  },
  mounted() {
    this.isActive = this.show;
    const observer = new MutationObserver(this.moutationObserver);
    observer.observe(this.$refs.accordionBody as HTMLElement, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
    this.observer = observer;
    this.refreshHeight();
    window.addEventListener("resize", this.refreshHeight);
  },
  beforeUnmount() {
    this.observer?.disconnect();
    window.removeEventListener("resize", this.refreshHeight);
  },
  methods: {
    moutationObserver() {
      this.refreshHeight();
    },
    refreshHeight() {
      this.fullHeight = (this.$refs.accordionBody as HTMLElement).offsetHeight;
      if (this.show) {
        this.targetHeight = this.fullHeight;
      }
    },
    onTranstionEnd() {
      if (this.show) {
        this.isAuto = true;
      } else if (this.unmountOnHide) {
        this.isActive = false;
      }
    },
  },
  watch: {
    show(val) {
      if (val && !this.isActive) {
        this.isActive = val;
      }
      this.refreshHeight();
      this.isAuto = false;
      this.targetHeight = val ? 0 : this.fullHeight;
      this.$nextTick(() => {
        this.targetHeight = val ? this.fullHeight : 0;
      });
    },
  },
});
</script>
